import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../services/firebase";
import { showToast } from "../../services/toast";

type Props = {
  isLogin: boolean;
  setIsLogin: React.Dispatch<React.SetStateAction<boolean>>;
};

export const NavBarMenu = ({ isLogin, setIsLogin }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate("/login");
        setIsLogin(false);
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const onClickAuth = () => {
    if (isLogin) {
      handleLogout();
    } else {
      navigate("/login");
    }
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickMenuButton = (item: string) => {
    if (isLogin) {
      navigate(item);
    } else {
      navigate("/login");
      showToast("You have to login", "error");
    }
  };

  return (
    <Box sx={{ display: { xs: "flex", sm: "none" } }}>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<MenuIcon style={{ color: "black" }} />}
        onClick={(e) => handleClick(e)}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => navigate("/")}>Home</MenuItem>
        <MenuItem onClick={() => onClickMenuButton("myChecks")}>
          My Checks
        </MenuItem>
        <MenuItem onClick={onClickAuth}>
          {isLogin ? "Logout" : "Login"}
        </MenuItem>
      </Menu>
    </Box>
  );
};
